<template lang="pug">

</template>

<script>
import { openMember } from "@/CommonDP/components/chooseMember/leftCom.js";
export default {
  data() {
    return {};
  },
  computed: {
    // 外部
    isOut() {
      return window.location.href.indexOf("jsName=BimEx") !== -1;
    }
  },
  created() {
    this.queryUrl();
  },
  methods: {
    /**
     * @description 打开选择人员弹窗
     * @param {object} props 传递给弹窗的props
     * @param {boolean} props.filterOneself 1/0 是否过滤当前用户 ,默认为false
     * @param {number} props.max? 限制人数，可多选单选人员
     * @param {MemberType[]} props.codePri 权限列表： ALL_NAV_LIST 中code组成的数组
     * @param {BaseMemberItem[]} props.usersList 人员信息的数组列表：userSelected抛出去的数组
     * @param {string} props.userIds 人员列表 用户id字符串,仅支持userId,使用,隔开
     ******
     * @param {string} props.isLowcode 是否低代码的人员选择 1/0 为1时必须搭配type字段使用
     * @param {string} props.curDeptId 当前部门
     * @param {string} props.deptId 部门id
     * @param {string} props.prjId 项目id
     * @param {string} props.prjRoleId 项目角色id
     * @param {string} props.specRoleId 专业角色id
     * @param {string} props.sysRoleId 系统角色id
     * @param {string} props.labelRole 标签 ///暂时还没用
     * @returns {Promise<BaseMemberItem[]>}
     */
    async queryUrl() {
      const props = this.$route.query || {};
      const { codePri, type, isLowcode, filterOneself } = props;
      const params = {
        ...props,
        filterOneself: filterOneself === "1",
        isLowcode: isLowcode === "1",
        codePri: codePri?.split(',') || [],
        fullscreen: true,
        type: Number(type)
      };
      try {
        const users = await openMember(params);
        await CefSharp.BindObjectAsync("cefSharpBrower");
        await cefSharpBrower.selPrjUserInfo(JSON.stringify(users));
        cefSharpBrower.closeWindow();
      } catch (error) {
        await window.CefSharp.BindObjectAsync("cefSharpBrower");
        window.cefSharpBrower.closeWindow();
      }
    }
  }
};
</script>

<style></style>
